import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from './common/components'
import { Dashboard } from './features/Dashboard'
import { Login } from './features/Login'
import './common/styles/index.scss'

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<ProtectedRoute />}>
        <Route path={''} element={<Dashboard />} />
      </Route>
      <Route path={'/login'} element={<Login />} />
    </Routes>
  </BrowserRouter>
)

export default App
